const DATE_TIME = new Intl.DateTimeFormat("tr-TR", { dateStyle: "short", timeStyle: "medium" });

export function dateTime(iso: string | null | undefined): string {
  return iso ? DATE_TIME.format(new Date(iso)) : "—";
}
